import React from 'react'
import './App.scss';
import {HashRouter as Router, Route, Switch} from 'react-router-dom'
import routes from './config/routes';
import {AuthProvider} from './providers/AuthProvider';

function App() {
    return (
        <AuthProvider> 
            <Router>
                <div>
                    <Switch>
                    {
                        routes.map((route, index) => (
                            <RouteWithSubRoutes key={index}
                                {...route}/>
                        ))
                    } 
                    </Switch>
                </div>
            </Router>
        </AuthProvider>
    );
}

// Rutas generales
const RouteWithSubRoutes = (route) => {
    return ( 
        <Route 
          path = { route.path }
          exact = { route.exact }
          render = { props => <route.component routes={route.routes} {...props} />}
        />
    )
}

export default App;
